export interface IDocumentoNoExigible {
    idDocumentoAfiliado: number
    nombre: string,
    documentoPropietario: string,
    idTipoDocumento: string
    propietario: string,
    createdAt: string,
}

export class DocumentoNoExigible implements IDocumentoNoExigible {
    private constructor(
        public idDocumentoAfiliado: number,
        public nombre: string,
        public propietario: string,
        public documentoPropietario: string,
        public idTipoDocumento: string,
        public createdAt: string,
    ){}

   

    static documentosObligatoiosDesdeObj(obj: any) {
        return new DocumentoNoExigible(
            obj.idDocumentoAfiliado,
            obj.nombre,
            obj.propietario,
            obj.documentoPropietario,
            obj.idTipoDocumento,
            obj.createdAt
        );
    }
}


